import React, { Fragment } from 'react';
import { GlobeIcon, MessageSquareIcon, PhoneIcon, MonitorIcon, ArrowRightIcon } from 'lucide-react';
const TelecomsCapabilities = () => {
  const channels = [{
    phase: 'Launch',
    title: 'SMS & USSD',
    description: 'Leverage infrastructure already in place for immediate deployment',
    icon: <MessageSquareIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-372" />,
    status: 'primary'
  }, {
    phase: 'Extend',
    title: 'Web & Voice (IVR)',
    description: 'Enable data users and accessibility features',
    icon: <PhoneIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-373" />,
    status: 'secondary'
  }, {
    phase: 'Integrate',
    title: 'Future Digital Channels',
    description: 'Seamlessly add new channels under one unified AI platform',
    icon: <MonitorIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-374" />,
    status: 'tertiary'
  }];
  return <>
      {/* Language and Accessibility Section */}
      <section className="py-16 bg-white" data-id="element-375">
        <div className="container mx-auto px-4" data-id="element-376">
          <div className="max-w-4xl mx-auto" data-id="element-377">
            <div className="text-center mb-12" data-id="element-378">
              <div className="inline-block p-4 bg-[#e5f8f7] rounded-full mb-4" data-id="element-379">
                <GlobeIcon className="h-12 w-12 text-[#54d4cb]" data-id="element-380" />
              </div>
              <h2 className="text-3xl font-bold mb-4" data-id="element-381">
                Language & Accessibility
              </h2>
              <p className="text-xl text-gray-600" data-id="element-382">
                Designed for inclusivity across all markets and demographics
              </p>
            </div>
            <div className="bg-gradient-to-br from-[#e5f8f7] to-white rounded-lg p-8 shadow-sm" data-id="element-383">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-384">
                <div data-id="element-385">
                  <h3 className="text-xl font-semibold mb-3 text-[#2d8a84]" data-id="element-386">
                    Multi-Language Support
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-387">
                    The system supports multi-language operation and can be
                    localized to any region.
                  </p>
                  <p className="text-gray-700" data-id="element-388">
                    Primary rollout typically includes dominant national or
                    regional languages, with optional expansion into local
                    languages to ensure complete inclusivity.
                  </p>
                </div>
                <div data-id="element-389">
                  <h3 className="text-xl font-semibold mb-3 text-[#2d8a84]" data-id="element-390">
                    Universal Access
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-391">
                    Accessible to every subscriber regardless of device type,
                    literacy level, or technical proficiency.
                  </p>
                  <p className="text-gray-700" data-id="element-392">
                    Natural language processing enables intuitive interaction in
                    the user's preferred language and communication style.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Channel Expansion Section */}
      <section className="py-16 bg-gray-50" data-id="element-393">
        <div className="container mx-auto px-4" data-id="element-394">
          <div className="max-w-5xl mx-auto" data-id="element-395">
            <div className="text-center mb-12" data-id="element-396">
              <h2 className="text-3xl font-bold mb-4" data-id="element-397">
                Progressive Channel Expansion
              </h2>
              <p className="text-xl text-gray-600" data-id="element-398">
                Start with SMS, scale across all communication channels
              </p>
            </div>
            <div className="relative" data-id="element-399">
              {/* Desktop view with arrows */}
              <div className="hidden md:flex items-center justify-between" data-id="element-400">
                {channels.map((channel, index) => <Fragment key={index} data-id="element-401">
                    <div className="flex-1" data-id="element-402">
                      <div className="bg-white rounded-lg shadow-md p-6 h-full" data-id="element-403">
                        <div className="text-sm font-semibold text-[#54d4cb] mb-2" data-id="element-404">
                          {channel.phase}
                        </div>
                        <div className="mb-4" data-id="element-405">{channel.icon}</div>
                        <h3 className="text-xl font-semibold mb-2" data-id="element-406">
                          {channel.title}
                        </h3>
                        <p className="text-gray-600" data-id="element-407">{channel.description}</p>
                      </div>
                    </div>
                    {index < channels.length - 1 && <div className="px-4 flex items-center justify-center" data-id="element-408">
                        <ArrowRightIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-409" />
                      </div>}
                  </Fragment>)}
              </div>
              {/* Mobile view stacked */}
              <div className="md:hidden space-y-6" data-id="element-410">
                {channels.map((channel, index) => <div key={index} className="bg-white rounded-lg shadow-md p-6" data-id="element-411">
                    <div className="text-sm font-semibold text-[#54d4cb] mb-2" data-id="element-412">
                      {channel.phase}
                    </div>
                    <div className="mb-4" data-id="element-413">{channel.icon}</div>
                    <h3 className="text-xl font-semibold mb-2" data-id="element-414">
                      {channel.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-415">{channel.description}</p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
};
export default TelecomsCapabilities;